function formatDigits(digits: string): string {
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

export function getMaxBirthDate(): Date {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 18);
  d.setHours(0, 0, 0, 0);
  return d;
}

function maskDate(value: string, _maxBirthDate?: Date): string {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  return formatDigits(digits);
}

export default maskDate;
